"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewedDocument = function ReviewedDocument(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 5.5H8C7.93433 5.49995 7.86929 5.51285 7.8086 5.53796C7.74792 5.56307 7.69278 5.5999 7.64634 5.64634C7.5999 5.69278 7.56307 5.74792 7.53796 5.8086C7.51285 5.86929 7.49995 5.93433 7.5 6V18C7.5 18.1326 7.55268 18.2598 7.64645 18.3536C7.74021 18.4473 7.86739 18.5 8 18.5H16C16.1326 18.5 16.2598 18.4473 16.3536 18.3536C16.4473 18.2598 16.5 18.1326 16.5 18V6C16.5 5.86739 16.4473 5.74021 16.3536 5.64645C16.2598 5.55268 16.1326 5.5 16 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11.9998 15.4996C11.9342 15.4997 11.8692 15.4868 11.8086 15.4617C11.7479 15.4365 11.6929 15.3997 11.6465 15.3532L9.64652 13.3532C9.59963 13.307 9.56236 13.2519 9.53684 13.1911C9.51133 13.1304 9.49808 13.0652 9.49787 12.9993C9.49765 12.9334 9.51047 12.8681 9.53558 12.8072C9.56069 12.7463 9.5976 12.691 9.64419 12.6444C9.69078 12.5978 9.74612 12.5609 9.80703 12.5358C9.86794 12.5107 9.93322 12.4978 9.9991 12.498C10.065 12.4983 10.1302 12.5115 10.1909 12.537C10.2517 12.5625 10.3068 12.5998 10.3531 12.6467L12.3531 14.6467C12.4229 14.7166 12.4704 14.8056 12.4897 14.9025C12.5089 14.9994 12.499 15.0998 12.4612 15.1911C12.4234 15.2823 12.3594 15.3604 12.2773 15.4152C12.1951 15.4701 12.0986 15.4994 11.9998 15.4995L11.9998 15.4996Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11.9998 15.4999C11.9009 15.4999 11.8042 15.4706 11.722 15.4156C11.6398 15.3607 11.5757 15.2826 11.5379 15.1912C11.5 15.0999 11.4901 14.9993 11.5094 14.9023C11.5287 14.8053 11.5763 14.7163 11.6463 14.6463L17.6463 8.64633C17.6926 8.59951 17.7477 8.5623 17.8085 8.53685C17.8693 8.51141 17.9345 8.49822 18.0003 8.49805C18.0662 8.49788 18.1315 8.51073 18.1924 8.53586C18.2533 8.561 18.3086 8.59792 18.3552 8.6445C18.4018 8.69109 18.4387 8.74642 18.4638 8.80732C18.489 8.86821 18.5018 8.93348 18.5016 8.99936C18.5015 9.06524 18.4883 9.13043 18.4628 9.1912C18.4374 9.25196 18.4002 9.3071 18.3533 9.35344L12.3533 15.3534C12.307 15.3999 12.2518 15.4368 12.1912 15.4619C12.1305 15.4871 12.0655 15.5 11.9998 15.4999Z",
    fill: props.foregroundColor
  }));
};

ReviewedDocument.defaultProps = {
  altText: "Reviewed Document",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
ReviewedDocument.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ReviewedDocument;
exports.default = _default;